import axios from 'axios';
import { PRICElIST_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getBrandChargeDiscount = (brandId) => {
  return axios({
    method: 'get',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/charge-discount',
    headers: getHeaders(),
  });
};


export const postBrandChargeDiscount = (brandId, data) => {
  return axios({
    method: 'post',
    url: PRICElIST_BASE_URL + '/api/secure/v1/brand/' + brandId + '/charge-discount',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putBrandChargeDiscount = (brandId, data) => {
  return axios({
    method: 'put',
    url: PRICElIST_BASE_URL + '/api/secure/v1/brand/' + brandId + '/charge-discount',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBrandStoreChargeDiscount = (brandId, storeId) => {
  return axios({
    method: 'get',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/store-charge-discount/' +
      storeId,
    headers: getHeaders(),
  });
};

export const postBrandStoreChargeDiscount = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/store-charge-discount',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putBrandStoreChargeDiscount = (brandId, data) => {
  return axios({
    method: 'put',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/store-charge-discount',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getChargeDiscountMode = () => {
  return axios({
    method: 'get',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/charge-discount-mode',
    headers: getHeaders(),
  });
};